export default "__VITE_ASSET__Bume1W0J__"